import { v4 as uuidv4 } from 'uuid';
import { getCookie, metricsLog, setCookie } from './utils';
import { Subject } from 'rxjs';
import { jwPlayer$ } from './player-adaptor/jwPlayer$';
import { dailymotionPlayer$ } from './player-adaptor/dailymotionPlayer$';

import { postRequest } from './postRequest';
import { completionTime } from './completionTime';
import { videoId } from './videoId';
import { PixelsVideoEvent, VideoProvider } from '../../constants/Video';
import { videoDuration } from './videoDuration';
import { videoSession } from './videoSession';
import { runningOrderPosition } from './runningOrderPosition';
import { fcPlayer$ } from './player-adaptor/fcPlayer$';
import { adCompletionTime } from './adCompletionTime';
import { adDuration } from './adDuration';
import { eventType } from './eventType';
import { adClick } from './adClick';
import { playerEventManager } from './playerEventManager';
import { adError } from './adError';
import { adRequest } from './adRequest';
import { startImpression } from './startImpression';
import { highestCPM } from './highestCPM';
import { campaignId } from './campaignId';
import { adPos } from './adPos';
import { completed } from './completed';
import { adSkipped } from './adSkipped';
import { addedByPixels } from './addedByPixels';
import { integrationType } from './integrationType';
import { pixelsUUIDKey } from './constants';
import { clusterIndex } from './clusterIndex';
import { designVariant } from './designVariant';
import { sessionId } from './sessionId';
import { contextual } from './contextual';


const initDataProfile = (sub: Subject<[string, any]>, typeOfIntegration: string): Subject<[string, any]> => {
  if (!getCookie(pixelsUUIDKey)) {
    const uuid = uuidv4();
    setCookie(pixelsUUIDKey, uuid, 365);
  }

  const id = getCookie(pixelsUUIDKey);

  metricsLog(`storageKey is ${id}`);

  [
    startImpression,
    playerEventManager,
    adRequest,
    adError,
    eventType,
    videoId,
    videoDuration,
    completionTime,
    videoSession,
    runningOrderPosition,
    adClick,
    highestCPM,
    addedByPixels,
    adCompletionTime,
    adDuration,
    adSkipped,
    campaignId,
    completed,
    adPos,
    integrationType,
    designVariant,
    sessionId,
    clusterIndex,
    contextual,
    postRequest,
    // resetState,
  ].forEach(fn => fn(sub, pixelsUUIDKey, typeOfIntegration));

  // start dispatching initial event
  sub.next([PixelsVideoEvent.INIT, null]);

  return sub;
};

(async () => {
  window._pixelsPlayer = window._pixelsPlayer || [];
  if (window._pixelsPlayer.length > 0) {
    const [domIdOrPlayer, platform, aid]: [string | any, VideoProvider, string] = window._pixelsPlayer.pop();
    switch (platform) {
      case VideoProvider.DAILYMOTION: {
        const player = await window.dailymotion.getPlayer(domIdOrPlayer).catch((error: Error) => {
          console.error(error);
          return;
        });
        if (player) {
          initDataProfile(dailymotionPlayer$(player, aid), 'hero');
        }
        break;
      }
      case VideoProvider.FCPLAYER:
        initDataProfile(fcPlayer$(domIdOrPlayer, aid), 'hero');
        break;
      case VideoProvider.JWPLAYER:
        initDataProfile(jwPlayer$(window.jwplayer(domIdOrPlayer), aid), 'hero');
        break;
      default:
        console.warn(`Unrecognisable player platform: ${platform}`);
    }
  }
  window.pixelsMetrics = initDataProfile;
})();
